import api from "../api";

const campaignApi = {
  // Get all campaigns
  getAll: () =>
    api
      .get("/campaigns")
      .then((res) => res.data),

  // Create campaign
  create: (payload) =>
    api
      .post("/campaigns", payload)
      .then((res) => res.data),

  // Update campaign
  update: (id, payload) =>
    api
      .put(`/campaigns/${id}`, payload)
      .then((res) => res.data),

  // Delete campaign
  remove: (id) =>
    api
      .delete(`/campaigns/${id}`)
      .then((res) => res.data),
};

export default campaignApi;